import React from "react";


export function OrganisationSecurityContainer({ accessToken, name, email }) {
  return(
      <p>OrganisationSecurity</p>
  )
}
 